import { debouncer, documentReady } from "../utility/utils";

export const initializeVideo = (event) => {
  // Play videos on play button
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.video_block__trigger') || !!e.target.closest('a.video_block__trigger')) {
      e.preventDefault();

      const target = e.target.closest('.video_block');
      const trigger = target.querySelector('a.video_block__trigger');

      // Fade out trigger
      trigger.classList.add('fadeOut');
      setTimeout(function(){
        trigger.classList.add('hide');
      }, 300);

      // if the video is an iframe
      if(!!target.querySelector('iframe')){
        const iframe = target.querySelector('iframe');
        const src = iframe.getAttribute('src');
        const playSrc = src + '&autoplay=true';
        iframe.setAttribute('src', playSrc);
      } else {
        const video = target.querySelector('video');
        video.play();
      }
    }
  });
};
